import { render, staticRenderFns } from "./OptionCreateTestInput.vue?vue&type=template&id=87b6f796&scoped=true"
import script from "./OptionCreateTestInput.vue?vue&type=script&lang=js"
export * from "./OptionCreateTestInput.vue?vue&type=script&lang=js"
import style0 from "./OptionCreateTestInput.vue?vue&type=style&index=0&id=87b6f796&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87b6f796",
  null
  
)

export default component.exports